import React, { useEffect, useState } from 'react';
import ShowOperator from '../../Components/ShowOperator';
import ModalWarn from '../../Components/Modal/Warn/index'

export default function AttendantDetails(props) {
    const [ attendant, setAttendant ] = useState({
        cpf: '',
        name: '',
        organ: {value: '', label: ''},
        dt_inc: '',
        dt_canc_exp: '',
        unidades_vinculadas: []
    });

    const [ loadAttendant, setLoadAttendant ] = useState(false);
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)


    useEffect(() => {
        async function loadAttendantDetails() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está operando
                    id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                }),
            };
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/detalhaatendente`,
                        requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!
                        const organ={
                            value: data.CODIGO_ORGAO,
                            label: data.NOME_ORGAO
                        }
                        let unidades = [];
                        data.UNIDADES_VINCULADAS && data.UNIDADES_VINCULADAS.forEach((unidade) => {
                            unidades.push({
                                value: unidade.CODIGO_UNIDADE,
                                label: unidade.NOME_UNIDADE
                            })
                        })
                        setAttendant({
                            id_usuario_orgao: data.ID_USUARIO_ORGAO,
                            cpf: props.location.state.result_search.CPF_USUARIO,
                            name: props.location.state.result_search.NOME_USUARIO,
                            cpf_cadastrador: props.location.state.result_search.CPF_USUARIO_CADASTRADOR,
                            nome_cadastrador: props.location.state.result_search.NOME_CADASTRADOR,
                            organ: organ,
                            dt_inc: data.DATA_INCLUSAO,
                            dt_canc_exp: data.DATA_CANCELAMENTO,
                            unidades_vinculadas: unidades
                        }); 
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            // inserir a mensagem: data.message no aviso de erro
                            console.log(data.message);
                        } else {
                            // inserir mensagem genérica
                            console.log('Response error in gestao/detalhaatendente BackendBalcao');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    //setModalError(true);
                    console.log('Request error in gestao/detalhaatendente BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        if (!loadAttendant && props.location.state !== undefined) {
            loadAttendantDetails();
            setLoadAttendant(true);
        }
    }, [props, attendant, loadAttendant]);

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />

            <ShowOperator
                pageTitle='Detalhe do Atendente'
                expirationDateHint='(O usuário será automaticamente excluído e terá seu acesso revogado na data estipulada)'
                operator={attendant} 
                setOperator={setAttendant}
                loadOperator={loadAttendant}
                buttonBackRoute='/gerenciaratendentes'
                buttonEditRoute='/editaratendente'
                history={props.history}
                rangePages={rangePages}
                setRangePages={setRangePages}
            />
        </>
    );
}